import React from 'react';
import OffCanvas from "../UI/OffCanvas";

import RegRegContent from './RegRegContent';

const Register = () => {
    return (
        <OffCanvas type="cog">
            <RegRegContent/>
        </OffCanvas>
    );
};

export default Register;